module.exports = __webpack_public_path__ + "cd548f83433cf41e17a5f00a0bf4a562.pdf";